import { useCallback, useEffect } from 'react';
import { POPUP } from '@config/popups';
import { ROUTES } from '@routing/routes';
import { AppFCC } from '@types';
import { accountGetIsAuthorized } from '@selectors/account';
import { currentMemberGetProfileIsFilledAndApproved } from '@selectors/current-member';
import { usePopup } from '@hooks/popup';
import { useNavigator } from '@hooks/routing';
import { useTypedSelector } from '@hooks/store';
import { AccountFilledProfileRequiredModalProps } from '@popups/modals/account/account-filled-profile-required/types';
import { _FilledProfileRequiredProps } from './types';
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export const _FilledProfileRequired: AppFCC<_FilledProfileRequiredProps> = props => {
  const {
    children,
    //
    isAuthorized,
    profileIsFilledAndApproved,
    accessOnFailure
  } = props;
  useEffect(() => {
    if (!isAuthorized || profileIsFilledAndApproved == null ||
    // Data not loaded
    profileIsFilledAndApproved) {
      return;
    }
    accessOnFailure();
  }, [accessOnFailure, profileIsFilledAndApproved, isAuthorized]);
  if (!isAuthorized || profileIsFilledAndApproved) {
    return _jsx(_Fragment, {
      children: children
    });
  }
  return null;
};
export const FilledProfileRequired: AppFCC = props => {
  const {
    children
  } = props;
  const navigator = useNavigator();
  const {
    addPopup
  } = usePopup();
  const isAuthorized = useTypedSelector(accountGetIsAuthorized);
  const profileIsFilledAndApproved = useTypedSelector(currentMemberGetProfileIsFilledAndApproved);
  const accessFailure = useCallback(async () => {
    await navigator.navigate(ROUTES.profile.edit.index.getDescriptor());
    addPopup<AccountFilledProfileRequiredModalProps>({
      id: POPUP.ACCOUNT_FILLED_PROFILE_REQUIRED
    });
  }, [addPopup, navigator]);
  return _jsx(_FilledProfileRequired //
  , {
    isAuthorized: isAuthorized,
    profileIsFilledAndApproved: profileIsFilledAndApproved,
    accessOnFailure: accessFailure,
    children: children
  });
};